import PropTypes from 'prop-types';
import React from 'react';
import { isValidEmail } from '../../utils';
// @mui/icons-material
import Business from '@mui/icons-material/Business';
import Calendar from '@mui/icons-material/CalendarToday';

// @mui/material components
import InputAdornment from '@mui/material/InputAdornment';
import withStyles from '@mui/styles/withStyles';

// core components
import DatePicker from 'components/CustomInput/CalendarInput.js';
import CustomInput from 'components/CustomInput/CustomInput.js';
import ImageUpload from 'components/CustomUpload/ImageUpload.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';

const style = {
  infoText: {
    fontWeight: '300',
    margin: '10px 0 30px',
    textAlign: 'center',
  },
  inputAdornmentIcon: {
    color: '#555',
  },
  inputAdornment: {
    position: 'relative',
  },
};

class Step1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logo: '',
      name: '',
      nameState: '',
      startDate: '',
      startDateState: '',
      endDate: '',
      endDateState: '',
    };
  }
  sendState() {
    return this.state;
  }
  // function that verifies if a string has a given length or not
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }
  change(event, stateName, type, stateNameEqualTo) {
    var value = null;
    switch (type) {
      case 'email':
        if (isValidEmail(event.target.value)) {
          this.setState({ [stateName + 'State']: 'success' });
        } else {
          this.setState({ [stateName + 'State']: 'error' });
        }
        value = event.target.value;
        break;
      case 'length':
        if (this.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + 'State']: 'success' });
        } else {
          this.setState({ [stateName + 'State']: 'error' });
        }
        value = event.target.value;
        break;
      case 'date':
        this.setState({ [stateName + 'State']: 'success' });
        value = event._d;
        break;
      default:
        value = event.target.value;
        break;
    }
    this.setState({ [stateName]: value });
  }
  isValidated() {
    if (
      this.state.nameState === 'success' &&
      this.state.startDateState === 'success' &&
      this.state.endDateState === 'success'
    ) {
      return true;
    } else {
      if (this.state.nameState !== 'success') {
        this.setState({ nameState: 'error' });
      }
      if (this.state.startDateState !== 'success') {
        this.setState({ startDateState: 'error' });
      }
      if (this.state.endDateState !== 'success') {
        this.setState({ endDateState: 'error' });
      }
    }
    return false;
  }
  render() {
    const { classes } = this.props;
    return (
      <GridContainer justify='center'>
        <GridItem xs={12} sm={12}>
          <h4 className={classes.infoText}>
            Basic company information for the new company
          </h4>
        </GridItem>
        <GridItem xs={12} sm={4}>
          <ImageUpload getImageFile={(image) => this.setState({ logo: image })} />
        </GridItem>
        <GridItem xs={12} sm={6}>
          <CustomInput
            success={this.state.nameState === 'success'}
            error={this.state.nameState === 'error'}
            labelText={
              <span>
                Company Name <small>(required)</small>
              </span>
            }
            id='name'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => this.change(event, 'name', 'length', 3),
              endAdornment: (
                <InputAdornment
                  position='end'
                  className={classes.inputAdornment}
                >
                  <Business className={classes.inputAdornmentIcon} />
                </InputAdornment>
              ),
            }}
          />
          <DatePicker
            adornment={true}
            success={this.state.startDateState === 'success'}
            error={this.state.startDateState === 'error'}
            labelText={
              <span>
                Start Date <small>(required)</small>
              </span>
            }
            id='startdate'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => this.change(event, 'startDate', 'date'),
              placeholder: 'Start Date (required)',
              endAdornment: (
                <InputAdornment
                  position='end'
                  className={classes.inputAdornment}
                >
                  <Calendar className={classes.inputAdornmentIcon} />
                </InputAdornment>
              ),
            }}
          />
          <DatePicker
            adornment={true}
            success={this.state.endDateState === 'success'}
            error={this.state.endDateState === 'error'}
            labelText={
              <span>
                End Date <small>(required)</small>
              </span>
            }
            id='enddate'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => this.change(event, 'endDate', 'date'),
              endAdornment: (
                <InputAdornment
                  position='end'
                  className={classes.inputAdornment}
                >
                  <Calendar className={classes.inputAdornmentIcon} />
                </InputAdornment>
              ),
            }}
          />
        </GridItem>
      </GridContainer>
    );
  }
}

Step1.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(style)(Step1);
